import Stack from 'src/app/atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const FooterLegalContainer = styled(Stack)`
  width: 100%;
`;

export const FooterLegalStack = styled(Stack)`
  border-top: 1px solid var(--border-brand-alt);
`;
